// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__G9h9b","success":"AnswerItem_success__jkDq6","error":"AnswerItem_error__31viR"};